export default {
  meta: {
    title: '销售额估算',
  },
};
